import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/services/api/client";

export function useBootstrapQuery() {
  return useQuery({
    queryKey: ["terminal", "bootstrap"],
    queryFn: () => apiClient.bootstrap(),
    staleTime: 60_000,
  });
}

export function useBarsQuery(symbol: string, interval: string, adjust: string, limit = 500) {
  return useQuery({
    queryKey: ["market", "bars", symbol, interval, adjust, limit],
    queryFn: () => apiClient.getBars(symbol, interval, adjust, { limit }),
    enabled: Boolean(symbol),
  });
}

export function useFundamentalsQuery(symbol: string) {
  return useQuery({
    queryKey: ["market", "fundamentals", symbol],
    queryFn: () => apiClient.getFundamentals(symbol),
    enabled: Boolean(symbol),
  });
}

export function useFactorsQuery(symbol: string) {
  return useQuery({
    queryKey: ["market", "factors", symbol],
    queryFn: () => apiClient.getFactors(symbol),
    enabled: Boolean(symbol),
  });
}

export function useBoardsQuery(symbol: string) {
  return useQuery({
    queryKey: ["market", "boards", symbol],
    queryFn: () => apiClient.getBoards(symbol),
    enabled: Boolean(symbol),
  });
}
